import styled from 'styled-components';
import { SectionTitleSmall } from '@/components';

export const EventDetailsTitle = styled(SectionTitleSmall)`
  ${({ theme }) => theme.mediaBreakpointUp.md} {
    margin-bottom: ${({ theme }) => theme.spacing[20]};
  }
`;
